import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-55bc0acd"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "submenu-wrap" }
const _hoisted_2 = { class: "t-container" }
const _hoisted_3 = {
  key: 0,
  class: "submenu-wrap-list"
}
const _hoisted_4 = {
  key: 1,
  class: "submenu-wrap-left"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "submenu-wrap-left__text" }, "我要提问", -1))
const _hoisted_6 = {
  key: 2,
  class: "submenu-wrap-right"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "submenu-wrap-right__text" }, "对AI大赛有建议或疑问，请向我们提问", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.page === 'faq')
        ? (_openBlock(), _createElementBlock("ul", _hoisted_3, [
            _createElementVNode("li", {
              class: _normalizeClass(['submenu-wrap-list__item', _ctx.activeTab === 0 ? 'active' : '']),
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.changeTab(0)))
            }, "公开问题", 2),
            (_ctx.hasLogin)
              ? (_openBlock(), _createElementBlock("li", {
                  key: 0,
                  class: _normalizeClass(['submenu-wrap-list__item', _ctx.activeTab === 1 ? 'active' : '']),
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.changeTab(1)))
                }, "我的问题", 2))
              : _createCommentVNode("", true)
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("img", {
              src: "https://static.wecity.qq.com/miying/left-arrow-1d8be1c4d8698e2ed9d29b6fcf9ce070.png",
              alt: "",
              class: "submenu-wrap-left__arrow",
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.backFaq && _ctx.backFaq(...args)))
            }),
            _hoisted_5
          ])),
      (_ctx.hasLogin)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _hoisted_7,
            _createElementVNode("button", {
              class: "submenu-wrap-right__btn",
              onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.clickAskQues && _ctx.clickAskQues(...args)))
            }, "我要提问")
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}